<template>
  <div id="ConcessionDashboard">
    <jt-dashboard :title="$gettext('DASHBOARD_CONCEPTION_TITLE')">
      <div class="card col-span-6 row-span-6" >
        <consumer-unit />
      </div>
      <div class="card col-span-6 row-span-6" >
        <consumer-unit-type />
      </div>
    </jt-dashboard>
  </div>
</template>

<script>
import JtLineChart from 'src/components/charts/JtLineChart.vue'
import JtCardDefault from 'src/components/dashboard/dashboard-card-components/base/JtCardDefault.vue'
import JtCardGaugeChart from 'src/components/dashboard/dashboard-card-components/chart-card/chart-type/JtCardGaugeChart.vue'
import JtFormCard from 'src/components/dashboard/dashboard-card-components/JtFormCard.vue'
import JtInfoCard from 'src/components/dashboard/dashboard-card-components/JtInfoCard.vue'
import JtDashboard from 'src/components/dashboard/JtDashboard.vue'
import { Component, Vue } from 'vue-property-decorator'
import ConsumerUnit from './ConsumerUnit.vue'
import ConsumerUnitType from './ConsumerUnitType.vue'

@Component({
  name: 'ConcessionDashboard',
  components: {
    JtDashboard,
    JtInfoCard,
    JtCardDefault,
    JtFormCard,
    JtCardGaugeChart,
    JtLineChart,
    ConsumerUnit,
    ConsumerUnitType
  }
})
export default class ConcessionDashboard extends Vue {
}
</script>

<style lang='stylus' scoped>
@import '~quasar-variables';

#ConcessionDashboard {

}
</style>
